import brand from '@helpers/brand';
import { paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import { Theme } from '../Misc/SectionWrapper/SectionWrapper';
const Container = styled.ul `
  display: flex;
  gap: 12px;
`;
const Tag = styled.li `
  ${paragraphSmall};

  --sectionBackground: ${brand.primary.blue};

  background: var(--sectionBackground, transparent);
  color: ${brand.global.white};
  border-radius: 8px;
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-weight: 700;

  &[data-theme=${Theme.BlueGradient}],
    &[data-theme=${Theme.GreenGradient}],
    &[data-theme=${Theme.OrangeGradient}],
    &[data-theme=${Theme.PurpleGradient}],
    &[data-theme=${Theme.RedGradient}] {
    --gradStart: ${brand.primary.blue};
    --sectionBackground: linear-gradient(83deg, var(--gradStart) 18.5%, var(--gradEnd) 82%);
  }

  &[data-theme=${Theme.BlueGradient}] {
    --gradEnd: ${brand.primary.cyan};
  }

  &[data-theme=${Theme.GreenGradient}] {
    --gradEnd: ${brand.primary.green};
  }

  &[data-theme=${Theme.OrangeGradient}] {
    --gradEnd: ${brand.primary.orange};
  }

  &[data-theme=${Theme.PurpleGradient}] {
    --gradEnd: ${brand.primary.purple};
  }

  &[data-theme=${Theme.RedGradient}] {
    --gradEnd: ${brand.primary.red};
  }
`;
const CardTagsStyles = {
    Container,
    Tag,
};
export default CardTagsStyles;
